import * as React from "react";
import { EMPTY_ARRAY } from "./empty.js";
function useOnMount(fn) {
  React.useEffect(fn, EMPTY_ARRAY);
}
export {
  useOnMount
};
//# sourceMappingURL=useOnMount.js.map
